import { IApplicationState } from '../../types/redux';

export function selectPage(state: IApplicationState) {
  return state.page;
}
